"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withInputValidation = void 0;
const withInputValidation = function (callback, schema) {
  return function (payload) {
    const validatedInput = schema.parse(payload);
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    return callback(validatedInput, ...rest);
  };
};
exports.withInputValidation = withInputValidation;